import HandshakeIcon from "@mui/icons-material/Handshake";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import LayersIcon from "@mui/icons-material/Layers";

export const DetailsData = [
  {
    id: 1,
    icon: <FaceRetouchingNaturalIcon />,
    heading: "Expertise",
    feel: "I'm expert in these",
    lang: "React, JavaScript, ES6, Redux, React-Router, Context Api, Bootstrap v5, CSS4, HTML5, Responsive Design.",
    tools: <LayersIcon />,
    toolsdetails: ["VSCode", "Sublime Text", "CodeBlocks", "Visual Studio"],
    dataAos: "zoom-in-up",
  },
  {
    id: 2,
    icon: <LocalLibraryIcon />,
    heading: "Comfortable",
    feel: "I feel comfortable in these",
    lang: "NodeJS, ExpressJS, Material UI, styled components, Netlify, Heroku.",
    tools: <LayersIcon />,
    toolsdetails: ["XAMPP", "Github", "Terminal"],
    dataAos: "zoom-in-down",
  },
  {
    id: 3,
    icon: <HandshakeIcon />,
    heading: "Familiar",
    feel: "I'm familiar in these",
    lang: "VueJs, React Native, Python, Windows Software, Android Application.",
    tools: <LayersIcon />,
    toolsdetails: ["PyCharm", "Git Bash", "VSCode", "Android Studio"],
    dataAos: "zoom-in-left",
  },
];
